import reactComponentLoader from 'scripts/react-component-loader'

import MyOrders from '../MyOrders'

reactComponentLoader(MyOrders, '[data-my-orders]')
